import React from "react";

export const TaskManagment = React.lazy(() => import("./TaskManagment"));

export const TaskBoard = React.lazy(() => import("./TaskBoard"));
export const ViewTaskManagment = React.lazy(() => import("./ViewTaskManagment"));
export const ModernViewTaskManagement = React.lazy(() => import("./ModernViewTaskManagement"));
export const ViewWorkSummary = React.lazy(() => import("./ViewWorkSummary"));
export const ReportSummary = React.lazy(() => import("./ReportSummary"));
export const LeaveSummaryList = React.lazy(() => import("./LeaveSummaryList"));